export default __webpack_public_path__ + "assets/media/placeholder-product.19043382.svg";